import testRule from 'skypager-util/lib/path-matcher'

export const rules = [
  /\.(png|jpg|gif)$/i
]

export const testDocument = (doc) => (
  typeof rules.find(rule => testRule(rule, doc.fileBaseName)) !== 'undefined'
)


// WEBPACK FOOTER //
// ./src/document-types/asset.js